import { HelpCircle } from 'lucide-react';
import { useTranslation } from '../../context/TranslationContext';
import { translateWithFallback } from '../../utils/translateWithFallback';
import { useProductTour } from '../../hooks/useProductTour';
import type { TourId } from './tours/types';

interface TourHelpButtonProps {
    tourId: TourId;
    className?: string;
}

/**
 * Discrete ? control to retrigger the page tour.
 * Does not clear per-tour completion flags — replay only.
 */
const TourHelpButton = ({ tourId, className = '' }: TourHelpButtonProps) => {
    const { t } = useTranslation();
    const tr = (key: string, fb: string) => translateWithFallback(t, key, fb);
    const { startTour, isActive } = useProductTour();

    return (
        <button
            type="button"
            data-tour-id="tour.help"
            onClick={() => startTour(tourId, { markCompleteOnEnd: false })}
            disabled={isActive}
            className={`inline-flex min-h-11 min-w-11 items-center justify-center rounded-full border border-[color-mix(in_srgb,var(--accent-color),transparent_50%)] text-[var(--text-color)] transition hover:bg-[color-mix(in_srgb,var(--accent-color),transparent_85%)] disabled:opacity-50 ${className}`}
            aria-label={tr('tour.help.aria', 'Show how this page works')}
            title={tr('tour.help.aria', 'Show how this page works')}
        >
            <HelpCircle className="h-5 w-5" aria-hidden />
        </button>
    );
};

export default TourHelpButton;
